import {
    ButtonGroup,
    ButtonIcon
} from '@wg/wows-react-uikit'
import classNames from 'classnames'
import * as React from 'react'
import { translate } from 'react-i18next'
import { IClan } from '../../../Reducers/ReducerSupply'
import settings from '../../../settings'
import { ClanDescriptionButtonTooltip } from '../../../tooltips'
import { ButtonJoinClan } from '../UIKit'
import styles from './ClanTitle.scss'

export type IProps = {
    isFetchingJoinClan: boolean,
    title: string | React.Node,
    currentAccount: any, // FIXME
    isOwn: boolean,
    clan: IClan,
    subTitle: string,
    hasClanDescription: boolean,

    onAcceptInvite: () => void,
    onSendApplication: () => void,
    onClanDescriptionClick: () => void,

    t: (s: string) => string
}


export class ClanTitle extends React.PureComponent<IProps> {
    render() {
        const t = this.props.t

        let clanDetails = null
        if (this.props.currentAccount.id && !this.props.currentAccount.clanId) {
            clanDetails = (
                <div className={styles.buttonWrapper}>
                    <ButtonGroup
                        spinnerLabel={''}
                        key="button-group"
                        isLoading={this.props.isFetchingJoinClan}
                        textAlign="left"
                    >
                        <ButtonJoinClan
                            clan={this.props.clan}
                            currentAccount={this.props.currentAccount}

                            onAcceptInvite={this.props.onAcceptInvite}
                            onSendApplication={this.props.onSendApplication}
                        />
                    </ButtonGroup>
                </div>
            )
        } else if (+this.props.clanId === this.props.currentAccount.clanId) {
            clanDetails = (
                <div className={styles.isOwnClan}>{t('Это ваш клан')}</div>
            )
        }

        const subTitle = this.props.subTitle ? <div className={styles.subTitle}>{this.props.subTitle}</div> : null
        let clanDescriptionButton = null
        if (this.props.hasClanDescription) {
            clanDescriptionButton = (
                <ButtonIcon
                    type="clan-info"
                    tooltipContent={(<ClanDescriptionButtonTooltip />)}
                    onClick={this.props.onClanDescriptionClick} />
            )
        }

        const classNameBase = classNames(styles.base, {
            [styles.isNavalBaseEnabled]: settings.supply.isEnabled,
        })

        return (
            <div className={classNameBase}>
                <div className={styles.title}>
                    {this.props.title}
                </div>
                <div className={styles.clanDescription}>{clanDescriptionButton}</div>
                {clanDetails}
            </div>
        )
    }
}


export default translate()(ClanTitle)